export default __webpack_public_path__ + "static/media/twitter-black.bfe23264.svg";